import { css } from '@emotion/css';

import { bgColor } from '@/utils/styles';

import { IconPickerColorConfigItem } from './consts';

export const hoverBgColor = (color: string) => css`
  :hover {
    background-color: ${color};
  }
`;

export const activeBgColor = (color: string) => css`
  :active {
    background-color: ${color};
  }
`;

export const iconPickerButtonStyles = (config: IconPickerColorConfigItem['color']) => css`
  ${bgColor(config.background)}
  ${hoverBgColor(config.hover)}
  ${activeBgColor(config.active)}
`;

export const iconPickerStaticButtonStyles = (config: IconPickerColorConfigItem['color']) => css`
  ${bgColor(config.background)}
  ${hoverBgColor(config.background)}
`;
